module.exports = __webpack_public_path__ + "assets/img/13.b703f577.png";